import i18n from 'i18next';
import logging from '../service/logging';

export const offerRefresh = (e: string) => {
   logging.error(e);
   // eslint-disable-next-line no-alert
   confirm(i18n.t('general.errorRefreshPage')) && location.reload();
   throw new Error(e);
};
